// theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00796b', // Teal Green
    },
    secondary: {
      main: '#004d40', // Darker Teal
    },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        asterisk: {
          color: '#d32f2f', // Red color for asterisk
          '&$error': {
            color: '#d32f2f', // Optional: ensure it's red even in error state
          },
        },
      },
    },
  },
});

export default theme;
